function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
var prefixCls = 'eui-tabs';

var TabsNav = /*#__PURE__*/function (_Component) {
  _inherits(TabsNav, _Component);

  var _super = _createSuper(TabsNav);

  function TabsNav() {
    var _this;

    _classCallCheck(this, TabsNav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      triggerDiv: []
    });

    _defineProperty(_assertThisInitialized(_this), "bindEvent", function () {
      var triggerDiv = _this.state.triggerDiv;
      var trigger = _this.props.trigger;
      var type = trigger !== 'hover' ? 'click' : 'mouseenter';
      triggerDiv.forEach(function (item) {
        if (!item.dom) {
          return;
        }

        item.dom.addEventListener(type, trigger !== 'hover' ? function (e) {
          _this.handleClick(e, item.pos);
        } : function (e) {
          _this.handleMouseEnter(e, item.pos);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e, index) {
      _this.clickHandler(e, index);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e, index) {
      _this.clickHandler(e, index);
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e, index) {
      var _this$props = _this.props,
          tabClick = _this$props.tabClick,
          noChange = _this$props.noChange;
      var curItem = e.currentTarget;

      if (curItem.classList.contains('current')) {
        return;
      }

      if (!noChange) {
        curItem.parentNode.querySelector(".".concat(prefixCls, "-tab.current")).classList.remove('current');
        curItem.classList.add('current');
      }

      if (tabClick) {
        tabClick(index);
      }
    });

    return _this;
  }

  _createClass(TabsNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {// this.bindEvent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {// 事件解绑
      // this.triggerDiv.removeEventListener('mouseenter', this.handleMouseEnter);
      // this.triggerDiv.removeEventListener('click', this.handleClick);
      // if (!this.triggerDiv) { return; }
      // this.triggerDiv.forEach((item) => {
      //   if (!item.dom) { return; }
      //   item.dom.removeEventListener('mouseenter', this.handleMouseEnter);
      //   item.dom.removeEventListener('click', this.handleClick);
      // });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          activeIndex = _this$props2.activeIndex,
          list = _this$props2.list,
          renderOthers = _this$props2.renderOthers,
          className = _this$props2.className,
          trigger = _this$props2.trigger; // const {
      //   triggerDiv
      // } = this.state;

      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-nav ").concat(className || '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-nav-wrap")
      }, list.length > 0 && list.map(function (item, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: index === activeIndex ? "".concat(prefixCls, "-tab current") : "".concat(prefixCls, "-tab"),
          onClick: function onClick(e) {
            trigger !== 'hover' && _this2.handleClick(e, index);
          },
          onMouseEnter: function onMouseEnter(e) {
            trigger === 'hover' && _this2.handleMouseEnter(e, index);
          } // ref={(el) => { triggerDiv.push({ dom: el, pos: index }); }}
          // trigger={trigger}
          ,
          key: index.toString()
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-tab-link")
        }, /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-tab-label")
        }, item), renderOthers && renderOthers(item, index)));
      })));
    }
  }]);

  return TabsNav;
}(Component);

_defineProperty(TabsNav, "propTypes", {
  className: PropTypes.string,

  /** item 中 title 为必备字段 */
  list: PropTypes.array,
  trigger: PropTypes.oneOf(['click', 'hover']),

  /** 激活第几个item，默认为0 */
  activeIndex: PropTypes.number,

  /** tab 点击切换事件回调 */
  tabClick: PropTypes.func,

  /** 渲染其他内容 */
  renderOthers: PropTypes.func
});

_defineProperty(TabsNav, "defaultProps", {
  className: undefined,
  activeIndex: 0,
  trigger: 'click',
  tabClick: function tabClick() {},
  list: [],
  renderOthers: function renderOthers() {}
});

export default TabsNav;